module.exports = __webpack_public_path__ + "img/lily.238b17d3.png";